import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { titlesDataSource } from 'infrastructure/data-sources/titles';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { ITitleItem } from 'infrastructure/data-sources/titles';

type Options = IBaseSelectBoxOption<ITitleItem['id'], ITitleItem>[];

interface ITitleSelectBoxProps extends Omit<IBaseSelectBoxProps, 'options'> {}

const TitleSelectBox: React.FC<ITitleSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => titlesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default TitleSelectBox;
